import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import { TiUserAdd } from "react-icons/ti";
import { WiTime3 } from "react-icons/wi";

const FollowersFollowing = () => {
  const [isloading, setIsLoading] = useState(false);
  const [value, setValue] = React.useState("1");
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const tabs = [
    { label: "Followers", value: "1" },
    { label: "Following", value: "2" },
  ];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    getFollowing();
    getFollowers();
  }, []);

  const getColorFromName = (name) => {
    if (!name) return { backgroundColor: "hsl(0, 0%, 50%)" };

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;
    const saturation = 70 + (Math.abs(hash) % 30); // 70–99%
    const lightness = 50 + (Math.abs(hash) % 10);

    return {
      backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
    };
  };

  const getFollowing = async () => {
    const token = Cookies.get("token");
    setIsLoading(true);
    try {
      const result = await axios.get(BaseUrl + "getFollowing", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setFollowing(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };
  const getFollowers = async () => {
    const token = Cookies.get("token");
    setIsLoading(true);
    try {
      const result = await axios.get(BaseUrl + "getFollowers", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      console.log(result.data.status);
      if (result.data.status === 200) {
        setFollowers(result.data.data);
        console.log(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }finally {
      setIsLoading(false);
    }
  };
  // const handleAccept = async (id) => {
  //   const token = Cookies.get("token");
  //   const formData = new FormData();
  //   formData.append("id", id);
  //   try {
  //     const result = await axios.post(BaseUrl + `acceptrequest`, formData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json",
  //       },
  //     });
  //     if (result.data.status === 200) {
  //       getRecievedRequests();
  //       getData();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const handleDecline = async (id) => {
  //   const token = Cookies.get("token");
  //   const formData = new FormData();
  //   formData.append("id", id);
  //   try {
  //     const result = await axios.post(BaseUrl + `rejectrequest`, formData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json",
  //       },
  //     });
  //     if (result.data.status === 200) {
  //       getSendRequests();
  //       getData();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-10 min-h-screen ">
          <div className="container mx-auto flex flex-col lg:flex-row gap-4 py-4 px-4  sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4 ">
              <div className="bg-white border border-gray-300 rounded-lg shadow mb-4">
                <div className=" ">
                  <div className="border-b border-gray-200 py-3">
                    <h2 className="text-lg  font-thin px-4">
                      Shivam's Network
                    </h2>
                  </div>
                  <div className="flex">
                    <Box
                      className="muibox"
                      sx={{ width: "100%", typography: "body1" }}
                    >
                      <TabContext value={value}>
                        <Box
                          className="muibox"
                          sx={{ borderBottom: 1, borderColor: "divider" }}
                        >
                          <TabList
                            onChange={handleChange}
                            aria-label="Dynamic Tabs Example"
                            textColor="primary"
                            indicatorColor="primary"
                          >
                            {tabs.map((tab) => (
                              <Tab
                                key={tab.value}
                                label={tab.label}
                                value={tab.value}
                                sx={{
                                  color:
                                    value === tab.value ? "#1976D2" : "#757575",
                                  fontWeight:
                                    value === tab.value ? "bold" : "normal",
                                  fontSize: "16px",
                                  mx: 2,
                                  textTransform: "capitalize",
                                  // borderBottom: value === tab.value ? "3px solid green" : "none",
                                  // "&.Mui-selected": {
                                  //   color: "green",
                                  // },
                                  "&:hover": {
                                    backgroundColor: "#F3F4F6",
                                  },
                                }}
                              />
                            ))}
                          </TabList>
                        </Box>

                        <TabPanel value="1">
                          {followers && followers.length > 0 ? (
                            <div className="space-y-4  ">
                              {followers.map((conn, index) => (
                                <div
                                  key={index}
                                  className="flex items-center gap-6 pb-1 px-6 border-b"
                                >
                                  <Link to={`/user/profile/${conn.slug}`}>
                                    {conn.profile ? (
                                      <img
                                        src={conn.profile}
                                        alt={conn.name}
                                        className="w-12 h-12 rounded-full object-cover"
                                      />
                                    ) : (
                                      <div
                                        className="w-12 h-12 rounded-full  text-white flex items-center justify-center font-semibold text-lg"
                                        style={getColorFromName(
                                          conn.name || "?"
                                        )}
                                      >
                                        {conn.name.charAt(0)}
                                      </div>
                                    )}
                                  </Link>

                                  <Link
                                    to={`/user/profile/${conn.slug}`}
                                    className="flex-1 leading-5"
                                  >
                                    <div className="font-medium">
                                      {conn.name}
                                    </div>
                                    <div className="text-sm text-gray-700">
                                      {conn.headline}
                                    </div>
                                  </Link>

                                  <div className="flex items-center gap-4">
                                    <button className="text-blue-600 border border-blue-600 px-4 py-1 rounded-full text-sm hover:bg-blue-50">
                                      Following
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="w-full h-64 flex items-center justify-center">
                              <p className="text-gray-500 px-[10px]">
                                No Followers
                              </p>
                            </div>
                          )}
                        </TabPanel>

                        <TabPanel value="2">
                          {following && following.length > 0 ? (
                            <div className="space-y-4  ">
                              {following.map((conn, index) => (
                                <div
                                  key={index}
                                  className="flex items-center gap-6 pb-1 px-6 border-b"
                                >
                                  <Link to={`/user/profile/${conn.slug}`}>
                                    {conn.profile ? (
                                      <img
                                        src={conn.profile}
                                        alt={conn.name}
                                        className="w-12 h-12 rounded-full object-cover"
                                      />
                                    ) : (
                                      <div
                                        className="w-12 h-12 rounded-full  text-white flex items-center justify-center font-semibold text-lg"
                                        style={getColorFromName(
                                          conn.name || "?"
                                        )}
                                      >
                                        {conn.name.charAt(0)}
                                      </div>
                                    )}
                                  </Link>
                                  <Link
                                    to={`/user/profile/${conn.slug}`}
                                    className="flex-1 leading-5"
                                  >
                                    <div className="font-medium">
                                      {conn.name}
                                    </div>
                                    <div className="text-sm text-gray-700">
                                      {conn.headline}
                                    </div>
                                  </Link>
                                  <div className="flex items-center gap-4">
                                    <button className="text-blue-600 border border-blue-600 px-4 py-1 rounded-full text-sm hover:bg-blue-50">
                                      Following
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="w-full h-64 flex items-center justify-center">
                              <p className="text-gray-500 px-[10px]">
                                No Following
                              </p>
                            </div>
                          )}
                        </TabPanel>
                      </TabContext>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/4 ">
              <img
                src="https://placehold.co/200x200"
                alt="Profile picture"
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <div className=" text-center py-4 mt-8  border-t border-gray-300">
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-4">
                  <Link to="#" className="hover:underline">
                    About
                  </Link>
                  <Link to="#" className="hover:underline">
                    Help Center
                  </Link>
                  <Link to="#" className="hover:underline">
                    Privacy & Terms
                  </Link>
                </div>
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
                  <Link to="#" className="hover:underline">
                    Ad Choices
                  </Link>
                  <i className="fas fa-caret-down"></i>
                  <Link to="#" className="hover:underline">
                    Ad Choices
                  </Link>
                </div>
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
                  <Link to="#" className="hover:underline">
                    Advertising
                  </Link>
                  <Link to="#" className="hover:underline">
                    Business Services
                  </Link>
                  <i className="fas fa-caret-down"></i>
                </div>
                <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
                  <Link to="#" className="hover:underline">
                    Get the LinkedIn app
                  </Link>
                  <Link to="#" className="hover:underline">
                    More
                  </Link>
                </div>
                <div className="flex flex-wrap justify-center items-center mt-4">
                  <img
                    src="/Images/logo/ls-linked-logo.png"
                    alt="LinkedIn logo"
                    className="mr-2"
                  />
                  <span className="text-sm text-gray-600">
                    LS-LinkedIn Corporation © 2025
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FollowersFollowing;
